import React from 'react';
import { CircleLoader } from 'react-spinners';

const Loader = (props) => {

  let { color, size, classe } = props;

  if (!size){
    size = 30
  }
  if (color === undefined ) {
    color = "#F35899"
  }

  return (
    <div className={`${classe} flex items-center w-full h-full`}>
      <div className="mx-auto">
        <CircleLoader color={color} size={`${size}px`} />
      </div>
    </div>
  );
}

export default Loader;
